module.exports = __webpack_public_path__ + "img/more_square.8efe14e1.svg";